import { render, staticRenderFns } from "./manager-questions.vue?vue&type=template&id=03143c70&scoped=true&"
import script from "./manager-questions.vue?vue&type=script&lang=js&"
export * from "./manager-questions.vue?vue&type=script&lang=js&"
import style0 from "./manager-questions.vue?vue&type=style&index=0&id=03143c70&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03143c70",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03143c70')) {
      api.createRecord('03143c70', component.options)
    } else {
      api.reload('03143c70', component.options)
    }
    module.hot.accept("./manager-questions.vue?vue&type=template&id=03143c70&scoped=true&", function () {
      api.rerender('03143c70', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/manager-questions/manager-questions.vue"
export default component.exports